import functionsMixins from "@/mixins/page/functionsMixins";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import http from "@/services/config/http-common";
import VarType from "@/model/types/resource/VarType";
import CurrentPageEntity from "@/model/entities/resource/entity/CurrentPageEntity";
import UserAuthEntity from "@/model/entities/resource/entity/UserAuthEntity";
import ui from "@/assets/scripts/ui";


export default {
    metaInfo() {
        return {
            title: this.getTitle
        }
    },
    mixins: [functionsMixins],
    data() {
        return {
            path: "",
            generalResource: false, //Indica se a página é um recurso geral e por tanto não irá verificar em auth
            assembleParams: null, //Parâmetros adicionais para montagem da página, sendo sobreposto localmente
            breadcrumb: [],
            enableGeneralFields: false,
            fieldsCustomizable: [],
            pageTitle: "", //Deixa fora para agilizar utilização em locais como breadcumbs
            currentPage: CurrentPageEntity,
            userAuth: UserAuthEntity,
            yesOrNotOptions: [{value: "Y", text: this.t('yes')}, {value: "N", text: this.t('no')}],
            yesOrNotOptionsAndAll: [{value: "", text: this.t('all')}, {value: "Y", text: this.t('yes')}, {
                value: "N",
                text: this.t('no')
            }],
            wordServiceRunItem: {},
            wordServiceRunPrimaryKey: 0,
            statusOptions: [{value: 1, text: 'Ativos'}, {value: 2, text: 'Inativos'}],
            mountAgain: false,//Utilizar no padrão  v-if="!mountAgain" para reload propriedade deverá ser utilizada na pagina para reload
        }
    },
    methods: {

        reload() {
            this.mountAgain = true

            setTimeout(() => {
                this.mountAgain = false
            }, 200)

        },

        setMenuPageId(menuPageId){
            //Alterar a página ID do menu selecionada por outra (usado em override simples somente de página)
            this.currentPage.menuPageId = menuPageId
            this.$store.commit("setCurrentPage", this.currentPage)
        },

        focusByRef(ref) {
            if (this.$refs[ref] && this.$refs[ref].$el)
                this.$refs[ref].$el.getElementsByTagName('input')[0].focus()
        },

        /*Sempre pageId original sem override, será verificado internamente se há override e depois a substituição*/
        async getFieldsCustomizableGeneralByPageId(pageId) {

            const entity = this.fieldsCustomizable.find(item => item.entity === 'page')

            if (entity !== undefined) {

                const pathSend = entity.path + "setting/page-field/fieldsCustomizable/?pageId=" + pageId
                await http.get(pathSend).then((response) => {
                    this.injectFieldsCustomizable(entity.entity, response.data)
                })

            }

        },

        async getFieldsCustomizable(type) {

            const entity = this.fieldsCustomizable.find(item => item.entity === type)

            if (entity !== undefined) {

                if (type === 'page') {
                    this.injectFieldsCustomizable(entity.entity, this.userAuth.generalFieldsCustomizable)
                } else {


                    const id = this.form[entity.foreignKeyColumn]

                    if (id > 0) {

                        const pathSend = entity.path + "-field/fieldsCustomizable/?" + type + "Id=" + id
                        await http.get(pathSend).then((response) => {
                            this.injectFieldsCustomizable(entity.entity, response.data)
                        })
                    }
                }

            } else {
                console.log("Falha ao tentar localizar entidade informada")
            }

        },

        getViewFields(filterArray = []) {

            const viewFields = this.userAuth.viewFields.filter(a => {

                return filterArray.indexOf(a.key) === -1


            })

            return viewFields
        },

        injectFieldsCustomizable(type, arrayCustomizable) {

            let arrayReturn = arrayCustomizable

            if (this.form && this.form.fieldsCustomized !== undefined && arrayReturn != null && arrayReturn.length > 0) {

                for (let fieldCustomizable of arrayReturn) {


                    const fieldValue = this.form.fieldsCustomized.find(item => item.fieldId === fieldCustomizable.fieldId)
                    let value


                    if (fieldValue !== undefined) {

                        if (fieldCustomizable.var === VarType.type.BOOLEAN) {

                            if (fieldValue.integerValue === 1) {
                                value = true
                            } else {
                                value = false
                            }

                        } else if (fieldCustomizable.var === VarType.type.INTEGER) {
                            value = fieldValue.integerValue
                        } else if (fieldCustomizable.var === VarType.type.DOUBLE) {
                            value = fieldValue.doubleValue
                        } else if (fieldCustomizable.var === VarType.type.STRING) {
                            value = fieldValue.stringValue
                        } else if (fieldCustomizable.var === VarType.type.DATE) {
                            value = fieldValue.dateValue
                        }

                        fieldCustomizable.value = value

                    }

                }

            }

            this.fieldsCustomizable.find(item => item.entity === type).fields = arrayReturn

        },

        entityFieldCustomized(entity) {

            const arrayEntity = this.fieldsCustomizable.filter(item => item.entity === entity)

            if (arrayEntity.length > 0) {
                return arrayEntity[0].fields
            } else {
                return null
            }

        },




        async requestFieldCustomized(entity, fields, forSearchList = false) {

            let requestEntity = {
                entity: entity,
                fields: [],
            }


            for (const field of fields) {

                let type
                let value = field.value
                let hasValue = true


                if (field.var === VarType.type.BOOLEAN) {
                    //Booleano convertido para integer

                    type = "integer"

                    if (value === undefined || value == null) {
                        value = 0
                        hasValue = false
                    } else {
                        if (value) {
                            value = 1
                        } else {
                            value = 0
                        }
                    }

                } else if (field.var === VarType.type.INTEGER) {
                    type = "integer"

                    if (value === undefined || value == null) {
                        value = 0
                    }

                    if (value === 0)
                        hasValue = false


                } else if (field.var === VarType.type.DOUBLE) {
                    type = "double"

                    if (value === undefined || value == null) {
                        value = 0.0
                    }

                    if (value === 0.0)
                        hasValue = false


                } else if (field.var === VarType.type.STRING) {
                    type = "string"

                    if (value === undefined || value == null || value === "") {
                        value = ""
                        hasValue = false
                    }


                } else if (field.var === VarType.type.DATE) {
                    type = "date"

                    if (value === undefined || value == null) {
                        value = ""
                        hasValue = false
                    }

                }


                if (forSearchList) {
                    /*Padrão de envio para listas*/
                    const item = {
                        fieldId: field.fieldId,
                        hasValue: hasValue,
                        value: value
                    }



                    /*No caso das pesquisas somente envia se houver valor preenchido válido*/
                    requestEntity.fields.push(item)

                } else {
                    /*Padrão de envio para formulários*/
                    const item = {
                        fieldId: field.fieldId,
                        [type + "Value"]: value
                    }
                    requestEntity.fields.push(item)
                }

            }

            return requestEntity

        },

        addNoOption(modal_id, search) {
            this.openDialogForm(modal_id, search)
        },

        async executeDeleteByBulk(ids,msg, callBackSuccess,callBackError) {

            ui.msgConfirmDelete(this, async() => {

                const data = {
                    ids
                }

                await http.post(this.getPath()+"/deleteByBulk", data)
                    .then(response => {
                        callBackSuccess(response)
                    })
                    .catch(error => {
                        ui.generalResponseError(this,error,callBackError)
                    });

            }, msg)

        },

        async getUserAuth(setIsLoadingPage, setCurrentPage, type) {

            if (!this.generalResource) {

                await crudGeneral.getAssemble(this.getPath(), type, this.assembleParams)
                    .then(response => {

                        this.userAuth = response.data;
                        this.currentPage = this.userAuth.currentPage

                        if (setIsLoadingPage)
                            this.setIsLoadingPage(false)

                        if (setCurrentPage)
                            this.$store.commit("setCurrentPage", this.currentPage)


                    })
                    .catch(error => {
                        console.log('Erro externo: ' + error)
                    });

            } else {

                if (setCurrentPage) {
                    /*Seta uma página em branco mesmo*/
                    this.$store.commit("setCurrentPage", CurrentPageEntity)
                }

                this.setIsLoadingPage(false)

            }

        },

        openDialogWordServiceRun(item,primaryKey){

            this.wordServiceRunItem = item
            this.wordServiceRunPrimaryKey = primaryKey

            this.openDialogForm('modal-word-service-run')

        },

        async sendQueueWordReport(path, primaryKey, title) {

            await http.post(path + "/addWordReportQueue/" + primaryKey).then(async () => {
                console.log(title)
                //ui.toast(this,'Informação','<b>'+title+'</b> enviado para fila de processamento do Word VBA, abre o arquivo do Word para processamento deste item.')
            }).catch(error => {
                this.responseError(error)
            })

        },


        injectGeneralFields() {

            /*Injeta o tipo geral de campos*/
            this.fieldsCustomizable.push(
                {
                    entity: "page",
                    foreignKeyColumn: "pageId",
                    path: "",
                    fields: [],
                })

        },


        async mountedDefault(setIsLoadingPage = true, setCurrentPage = true, type = '') {

            if (this.enableGeneralFields) {
                this.injectGeneralFields()
            }

            if (setIsLoadingPage)
                this.setIsLoadingPage(true)

            await this.getUserAuth(setIsLoadingPage, setCurrentPage, type)
        }

    },
    computed: {


        getTitle() {

            if (this.pageTitle !== '') {
                return this.pageTitle
            } else {
                return this.$store.getters.getCurrentPage.pageTitle
            }

        },

        menuClicked() {
            return this.$store.getters.getMenuClicked
        },
        getIsLoadingPage() {
            //!! força boleano
            return !!this.$store.getters.getIsLoadingPage
        },
        getCurrentPage() {
            return this.currentPage
        },

    },
    async mounted() {


    },

}


